(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('InImageTypeDService', [
        '$http',
        '$q',
        function($http, $q) {
                this.getDefaultOptions = function() {
                    return {
						creativeWidth: '970',
						creativeHeight: '250',
						minWidth: 435,
						maxWidth: "100%",
						minHeight: 125,
						maxHeight: 250,
						closeActionTime: -1,
                    };

                };

            this.generateContent = function(scope, options){
                var template = ``;
                return template;
            };






        },
    ]);
})(window.angular);
